import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import ReactHtmlParser from 'react-html-parser';
import ReactOembedContainer from 'react-oembed-container';
import VideoPlayerElement from './VideoPlayerElement';
import Diptych from '../images/Diptych';
import Triptych from '../images/Triptych';

import '~styles/base/bodyelement.scss';

const sectionBreak = (<hr className="break content" />);

const BodyElement = ({ data }) => {
  switch (data.type) {
    case 'text': {
      // If text content is just *** then return hr
      if (data.content === '***') {
        return sectionBreak;
      }
      return (
        <p className="paragraph content">
          {ReactHtmlParser(data.content)}
        </p>
      );
    }
    case 'header': {
      return (
        <h1 className="section-header millerbanner-n4 content">
          {ReactHtmlParser(data.content)}
        </h1>
      );
    }
    case 'image': {
      const imgClass = (data.alignment !== ' ') ? `float-${data.alignment}` : 'content';
      // TODO Get credit from arc, lightbox?
      return (
        <figure className={imgClass}>
          <GatsbyImage
            image={getImage(data.localImage.childImageSharp)}
            alt={data.caption}
          />
          <figcaption className="img_caption">
            <div className="caption bentonsanscond-n4">{data.caption}</div>
          </figcaption>
        </figure>
      );
    }
    case 'video': {
      return (
        <VideoPlayerElement data={data} />
      );
    }
    case 'quote': {
      const quoteClass = data.subtype ? `${data.subtype} benton-n4` : 'pullquote benton-n4';
      const quoteBody = data.bodyElements
        ? data.bodyElements.map((body) => <div key={body._id}>{body.content}</div>)
        : (null);
      return (
        <blockquote className={quoteClass}>
          {quoteBody}
          {data.citation !== false
            && (
            <cite className="benton-n6">
              —
              {data.citation.content}
            </cite>
            )}
        </blockquote>
      );
    }
    case 'interstitial_link': {
      return (
        <div className="related">
          <span className="related--label bentonsanscond-n6">RELATED: </span>
          <a href={data.url} className="bentonsanscond-n6" target="_blank" rel="nofollow noreferrer">{ReactHtmlParser(data.content)}</a>
        </div>
      );
    }
    case 'divider': {
      return sectionBreak;
    }
    case 'gallery': {
      if (data.content_elements.length === 2) {
        return (<Diptych description={data.description} images={data.images} />);
      }

      if (data.content_elements.length === 3) {
        return (<Triptych description={data.description} images={data.images} />);
      }
      return null;
    }
    // to enable HTML, simply replace with commented code
    case 'raw_html': {
      return (null);
      // const dangerousHtml = { __html: data.content };
      // return (
      //   <div
      //     dangerouslySetInnerHTML={dangerousHtml}
      //   />
      // );
    }
    case 'oembed_response': {
      const html = get(data, 'raw_oembed.html', '');
      return (
        <ReactOembedContainer markup={html}>
          {ReactHtmlParser(html)}
        </ReactOembedContainer>
      );
    }
    default: {
      return null;
    }
  }
};

BodyElement.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.string,
    type: PropTypes.string,
    subtype: PropTypes.string,
    alignment: PropTypes.string,
    archieJson: PropTypes.string,
    url: PropTypes.string,
    srcSet: PropTypes.string,
    caption: PropTypes.string,
    bodyElements: PropTypes.arrayOf(
      PropTypes.shape({ content: PropTypes.string }),
    ),
    description: PropTypes.shape({
      basic: PropTypes.string,
    }),
    images: PropTypes.arrayOf(
      PropTypes.shape(),
    ),
    citation: PropTypes.shape({ content: PropTypes.string }),
  }).isRequired,
};

export default BodyElement;
